import React from 'react';
import PropTypes from 'prop-types';
import { MainContent } from '../../components/PeerChallenge/MainContent';
import HcpUserActionLinkTiles from '../../components/ActionLinkTile/hcpUserActionLinkTiles';
import { peerChallengeShape } from '../../components/PeerChallenge/shared/types';
import './challengePreview.scss';

const PChallengeContent = ({ resourceId, resource }) => (
    <div className="peer-challenge-preview-container">
        <MainContent resourceId={resourceId} peerChallengeData={resource} />
        <HcpUserActionLinkTiles />
    </div>
);

PChallengeContent.propTypes = {
    resourceId: PropTypes.string,
    resource: PropTypes.shape({ data: peerChallengeShape }),
};

PChallengeContent.defaultProps = {
    resourceId: null,
    resource: null,
};

export default PChallengeContent;
